<div class="modal-header p-1 mb-1">
  <h6 class="modal-title" id="modal-text-orange-bold">Subscription Status</h6>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-2 mb-2">  
  <div class="row">    
    <div class="col-md-12 col-lg-12 mb-4 align-items-stretch">
      <div class="table-responsive">
        <span style="width: 50px;">Tenant Name:</span>&nbsp;<span style="width: 50px;"><b>{{tenantDetail.tenantName}}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span style="width: 50px;">School Support:</span>&nbsp;<span style="width: 50px;"><b>{{tenantDetail.contactSupport}}</b></span>&nbsp;
        <br><br>
        <span>Subscription Status:</span>&nbsp;<span><b>{{tenantDetail.subscrStatus}}</b></span>&nbsp;&nbsp;
        <span>Subscription Name:</span>&nbsp;<span><b>{{tenantDetail.subscriptionDetail.name}}</b></span>&nbsp;
        <br><br>
        <span>Subscription Start:</span>&nbsp;<span><b>{{startDate}}</b></span>&nbsp;&nbsp;
        <span>Subscription End:</span>&nbsp;<span><b>{{endDate}}</b></span>&nbsp;         
      </div>
    </div>
  </div>
</div>

<!--<div class="modal-footer">
  <button type="button" class="btn-custom p-1" (click)="cancel()">Cancel</button>
</div>--> 
